import FrontCommonClass from './../customizationfrontcommon.js';
import CanvasClass from './canvas.js';
import DomClass from './dom.js';
import PanelClass from './panel.js';
import AjaxdataClass from './ajaxdata.js';
import BackdataClass from './back.js';
import { fabric } from "fabric";

export default class Populate {

    constructor(storage) {


        console.log('storage', storage);


        this.storage = storage;
        this.storage.pyml = '';
        if ($(window).height() > $(window).width()) {
            this.storage.verticalOrientation = true;
        }
        this.storage.fontsList = ['Roboto', 'Lobster', 'Luckiest Guy', 'New Rocker', 'Permanent Marker', 'Kranky', 'Frijole', 'Modak', 'Turret Road', 'Akronim', 'Creepster', 'Faster One', 'Special Elite', 'Caesar Dressing', 'Mark Script', 'Finger Paint'];
        this.storage.fabric = {
            filter: fabric.Image.filters
        }
        this.storage.back = [];
        this.storage.steps = [];
        this.storage.thumbs = []
        this.storage.icons = [];
        this.storage.canvasWidth = '';
        this.storage.SCALE_FACTOR = 1;
        this.storage.notice = {
            ratio: false
        };
        this.storage.ObjectLess = ["undefined", "null", null];
        this.storage.canvas = [];
        this.storage.canvastmp = [];
        this.storage.stepJsonCanvas = [];
        this.storage.canvasActive = [];
        this.storage.swiper = [];
        this.storage.arr_slogan = {
            images: [
                {
                    name: 'burger',
                    position: 1,
                    slogan: 'Mangez, Bougez',
                },
                {
                    name: 'cave',
                    position: 2,
                    slogan: 'Premier cru',
                },
                {
                    name: 'champagne',
                    position: 3,
                    slogan: 'Fête des bulles',
                },
                {
                    name: 'chat',
                    position: 5,
                    slogan: 'Carressez-moi !',
                },
                {
                    name: 'cocktail',
                    position: 1,
                    slogan: 'Avec modération',
                },
                {
                    name: 'coeur',
                    position: 5,
                    slogan: 'I love you',
                },
                {
                    name: 'color',
                    position: 3,
                    slogan: 'La vie en couleur',
                },
                {
                    name: 'decollete',
                    position: 8,
                    slogan: 'Dans les yeux SVP',
                },
                {
                    name: 'dollar',
                    position: 3,
                    slogan: 'Braquage en cours...',
                },
                {
                    name: 'eau',
                    position: 5,
                    slogan: 'Potable',
                },
                {
                    name: 'eiffel',
                    position: 3,
                    slogan: 'Welcome To Paris',
                },
                {
                    name: 'fleur',
                    position: 5,
                    slogan: 'La vie en rose',
                },
                {
                    name: 'fraise',
                    position: 3,
                    slogan: 'Une envie ?',
                },
                {
                    name: 'gold',
                    position: 5,
                    slogan: 'En Or !',
                },
                {
                    name: 'grenouille',
                    position: 3,
                    slogan: 'Soyez nature',
                },
                {
                    name: 'humour',
                    position: 5,
                    slogan: "Parlons d'amour",
                },
                {
                    name: 'iceberg',
                    position: 3,
                    slogan: 'Frissons garantis',
                },
                {
                    name: 'lapin',
                    position: 5,
                    slogan: 'Chaud lapin !',
                },
                {
                    name: 'levres',
                    position: 3,
                    slogan: 'KISS ME',
                },
                {
                    name: 'levrechoco',
                    position: 5,
                    slogan: 'Tellement bon',
                },
                {
                    name: 'macaron',
                    position: 3,
                    slogan: 'Craquant moelleux',
                },
                {
                    name: 'multifruits',
                    position: 5,
                    slogan: 'Fort en vitamines',
                },
                {
                    name: 'neige',
                    position: 3,
                    slogan: 'Sans limite',
                },
                {
                    name: 'oiseau',
                    position: 5,
                    slogan: "Drôle d'oiseau",
                },
                {
                    name: 'paris',
                    position: 3,
                    slogan: 'Paris by night',
                },
                {
                    name: 'plage',
                    position: 5,
                    slogan: 'Direction le paradis',
                },
                {
                    name: 'pomme_amour',
                    position: 3,
                    slogan: 'A croquer',
                },
                {
                    name: 'serpent',
                    position: 10,
                    slogan: 'Aie confiance',
                },
                {
                    name: 'sexy',
                    position: 3,
                    slogan: 'Belle vue',
                },
                {
                    name: 'ville',
                    position: 5,
                    slogan: 'The town',
                },
            ],
        };

        // console.log('objs', this.storage.objs);
        // console.log(JSON.stringify(this.storage.objs, null, 2))



        this.storage.HideControls = {
            tl: true,
            tr: true,
            bl: true,
            br: true,
            ml: false,
            mt: false,
            mr: false,
            mb: false,
            mtr: true,
        };
        this.storage.HideControlsAll = {
            tl: false,
            tr: false,
            bl: false,
            br: false,
            ml: false,
            mt: false,
            mr: false,
            mb: false,
            mtr: false,
        };

        this.class = {
            FrontCommon: new FrontCommonClass(this),
            Canvas: new CanvasClass(this),
            Dom: new DomClass(this),
            Ajax: new AjaxdataClass(this),
            Panel: new PanelClass(this),
            Back: new BackdataClass(this)
        };

        jQuery(function () {
            if ($('#personnalisation_admin').length) {
                //this.class.Back = new BackdataClass(this);
                console.log('admin okkkk');


                // import(/* webpackChunkName: "backClass" */"./back.js").then(backClass => {
                //     let backClass = backClass.default;
                //     this.class.Back = new backClass();
                // });
                console.log('loading back js');
                //            this.class.Back = new BackdataClass(this);
            }
        });

        this.init();
    }



    async init() {
        console.log('populate custom front common');
        this.class.FrontCommon.init();
        // var output = fs.readFileSync('someData.txt')
        // console.log(output)
    }

    setInterface(typeInterface) {

        fabric.Object.NUM_FRACTION_DIGITS = 17;

        let configObject;
        if (typeInterface === 'mobile') {
            this.storage.mobile = true;
            configObject = {
                objectCaching: false,
                transparentCorners: false,
                cornerColor: '#ffffff',
                cornerStyle: 'circle',
                cornerStrokeColor: "#fff",
                cornerSize: '7'
            }
        }
        else {
            this.storage.mobile = false;
            configObject = {
                objectCaching: false,
                transparentCorners: false,
                cornerColor: '#ffffff',
                cornerStyle: 'circle',
                cornerStrokeColor: "#fff",
                cornerSize: '14'
            }
        }

        fabric.Object.prototype.set(configObject);
        console.log('configObject', configObject);
    }
}
